import { Kbd } from "./kbd"

function OptAlt(props: React.ComponentProps<typeof Kbd>) {
  const isMac =
    typeof navigator !== "undefined" &&
    navigator.platform?.toLowerCase().includes("mac")
  return <Kbd {...props}>{isMac ? "⌥" : "Alt"}</Kbd>
}

export { OptAlt }
